import { render, staticRenderFns } from "./VendorReportTab.vue?vue&type=template&id=fd1552a2"
import script from "./VendorReportTab.vue?vue&type=script&lang=js"
export * from "./VendorReportTab.vue?vue&type=script&lang=js"
import style0 from "./VendorReportTab.vue?vue&type=style&index=0&id=fd1552a2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports